import { Controller } from "@hotwired/stimulus"
import * as SimpleSwitch from "a-simple-switch"

export default class extends Controller {
  connect() {
    new SimpleSwitch.Switch({ element: this.element })
  }
}
